import React from 'react';

import { TABLE_MENU_ITEM_BUTTON_CLASS } from './tableMenuUtils';

type TableMenuItemButtonProps = {
  onClick: (event: React.MouseEvent) => void;
  onKeyDown: (event: React.KeyboardEvent) => void;
  registerRef?: (element: HTMLButtonElement | null) => void;
  disabled?: boolean;
  children: React.ReactNode;
};

const TableMenuItemButton: React.FC<TableMenuItemButtonProps> = ({
  onClick,
  onKeyDown,
  registerRef,
  disabled = false,
  children,
}) => (
  <button
    type="button"
    ref={registerRef}
    onClick={onClick}
    onKeyDown={onKeyDown}
    disabled={disabled}
    role="menuitem"
    aria-disabled={disabled}
    className={`${TABLE_MENU_ITEM_BUTTON_CLASS} ${disabled ? 'text-gray-400 cursor-not-allowed opacity-50' : ''}`}
  >
    {children}
  </button>
);

export default TableMenuItemButton;
